/* eslint-disable no-use-before-define */
import React, { useEffect, useState } from 'react'
import TextField from '@material-ui/core/TextField'
import Autocomplete from '@material-ui/lab/Autocomplete'
import InputAdornment from '@material-ui/core/InputAdornment'
import SearchIcon from '@material-ui/icons/Search'
import './index.scss'

const AutocompleteCity = ({ towns, setSearchTown }) => {
  const [newTowns, setNewTowns] = useState([])

  useEffect(() => {
    if (towns?.length) {
      towns?.map(i => i?.town ? setNewTowns(prev => [...prev, i]) : setNewTowns(prev => [...prev, { ...i, town: 'Without city' }]))
    }
  }, [towns])

  return (
    <Autocomplete
      onSelect={e => setSearchTown(e?.target?.value)}
      className='selectCity'
      id='combo-box-demo'
      freeSolo
      options={newTowns}
      getOptionLabel={option => option?.town}
      style={{ width: 320 }}
      renderOption={(option, { selected }) => (
        <div className='itemsCity'>
          <div className='titleCity'>{option?.town}</div>
          <div className='countCity'>{option?.count} users</div>
        </div>
      )}
      renderInput={params => (
        <TextField
          placeholder='Search'
          variant='outlined'
          {...params}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <InputAdornment position='start'>
                <SearchIcon className='iconSearc' />
              </InputAdornment>
            ),
          }}
        />
      )}
    />
  )
}

export default AutocompleteCity
